import { Box, Button, DialogActions, DialogContent, DialogTitle, Grid, Icon, Modal, Typography, LinearProgress, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { ToastContent } from "..";
import { VForm, useVForm } from "../../forms";
import { useToast } from "../../hooks";
import { SinisterService } from "../../services/api/sinister/SinisterService";
import { IListagemUsuario, userService } from "../../services/api/user/userService";
import { returnMessageError } from "../../utils/returnMessageError";
import { AutoCompleteSinisterResponsible } from "../autoCompleteSinisterResponsible/AutoCompleteSinisterResponsible";

const style = {
	position: "absolute" as "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "35%",
	bgcolor: "background.paper",
	border: "1px solid #605e5e",
	boxShadow: 24,
	p: 2,
	borderRadius: "6px",
};

interface IResponsibleModalProps {
	isOpenModal: boolean;
	onclickConfirm?: () => void;
	isCloseModal: (isAddResponsible?: boolean) => void;
	idSinister: string;
}

export const ResponsibleModal: React.FC<IResponsibleModalProps> = ({ isOpenModal, isCloseModal, onclickConfirm, idSinister }) => {
	const { formRef } = useVForm();
	const [isLoading, setIsLoading] = useState(false);
	const [userSelected, setUserSelected] = useState<IListagemUsuario | null>(null);
	const [responsibles, setResponsibles] = useState<IListagemUsuario[]>([]);
	const toastHandler = useToast();

	// Função para buscar os responsáveis
	const handleGetUser = () => {
		userService
			.getManagers("", idSinister)
			.then((result) => {
				// Verifique os dados recebidos
				if (result instanceof Error) {
					const titleMessage = "Alerta!!";
					const contentMessage = "Erro: " + result?.message;
					toastHandler.present({
						type: "error",
						position: "top-right",
						messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
					});
				} else {
					setResponsibles(result.data); // Atualizando o estado com os responsáveis
				}
			})
			.catch((err: any) => {
				const { titleMessage, contentMessage } = returnMessageError(err);
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
				});
			});
	};

	useEffect(() => {
		if (isOpenModal) {
			handleGetUser(); // Buscar responsáveis ao abrir a modal
		}
	}, [isOpenModal]);

	// Função de salvar
	const handleSave = () => {
		if (userSelected) {
			setIsLoading(true);
			SinisterService.updateResponsible(idSinister, userSelected.id)
				.then((result: any) => {
					setIsLoading(false);
					if (result instanceof Error) {
						toastHandler.present({
							type: "error",
							position: "top-right",
							messageOrContent: <ToastContent title="Erro" content={result?.message} />,
						});
					} else {
						toastHandler.present({
							type: "success",
							position: "top-right",
							messageOrContent: <ToastContent title="Sucesso" content="Gestor adicionado com sucesso!" />,
						});

						// Chama onclickConfirm (se existir) após o sucesso
						if (onclickConfirm) {
							onclickConfirm();
						}

						isCloseModal(true); // Fechar modal
					}
				})
				.catch((err: any) => {
					setIsLoading(false);
					const { titleMessage, contentMessage } = returnMessageError(err);
					toastHandler.present({
						type: "error",
						position: "top-right",
						messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
					});
				});
		}
	};

	return (
		<Modal open={isOpenModal} onClose={() => isCloseModal()}>
			<Box sx={style}>
				<DialogTitle style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
					<Typography variant="h4" color="primary.main" sx={{ fontWeight: "300" }}>
						Responsável pelo Sinistro
					</Typography>
				</DialogTitle>
				<DialogContent style={{ display: "flex", justifyContent: "center", width: "100%" }}>
					<VForm
						ref={formRef}
						onSubmit={handleSave}
						placeholder="Your placeholder"
						onPointerEnterCapture={""}
						onPointerLeaveCapture={() => {}}
						style={{ width: "100%" }} // Adicione esta linha
					>
						<Grid container item direction="row" spacing={2} sx={{ width: "100%" }}>
							<Grid item xs={12} sm={12} md={12} lg={12} sx={{ width: "100%" }}>
								<AutoCompleteSinisterResponsible
									isExternalLoading={isLoading}
									labelSelect="Responsável pelo Sinistro"
									idSinister={idSinister}
									selected={(user) => setUserSelected(user)}
									value={userSelected}
									fullWidth
								/>
							</Grid>
						</Grid>
					</VForm>
				</DialogContent>
				<DialogActions style={{ display: "flex", justifyContent: "center" }}>
					<Button onClick={() => isCloseModal()} color="inherit" variant="contained" startIcon={<Icon>close</Icon>}>
						Cancelar
					</Button>
					<Button color="primary" variant="contained" startIcon={<Icon>check</Icon>} onClick={() => handleSave()}>
						Confirmar
					</Button>
				</DialogActions>
			</Box>
		</Modal>
	);
};
